// @flow

import React from 'react';
import {
  GroupTitleStyled,
  GroupItemCount,
  ClickPad,
} from './groupTitle.styled';
import Price from '../../../price';

type Props = {|
  title: string,
  price: number,
  count?: ?number,
  onClick?: Function,
  collapsible: boolean,
  isOpen?: boolean,
  showCount?: boolean,
|};

const GroupTitle = ({
  showCount, collapsible, title, price, count, onClick, isOpen = false,
}: Props) => (
  <GroupTitleStyled>
    <span>
      {title}
      {' '}
      {count && showCount && (
        <GroupItemCount>
          (
            {count}
          )
        </GroupItemCount>)}
    </span>
    <Price displayZeroes amount={price} />
    {collapsible && (<ClickPad
      onClick={onClick}
      isOpen={isOpen}
    />)}
  </GroupTitleStyled>
);

GroupTitle.defaultProps = {
  count: null,
  onClick: () => {},
  isOpen: false,
  showCount: false,
};

export default GroupTitle;
